module.exports = __webpack_public_path__ + "static/media/icon-chart-ipbstore.887c8fa6.svg";